import { render, staticRenderFns } from "./client-fields.html?vue&type=template&id=0df8b444&scoped=true&"
import script from "./client-fields.js?vue&type=script&lang=js&"
export * from "./client-fields.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df8b444",
  null
  
)

export default component.exports